import tippy from 'tippy.js'
import { each } from '../../utils/dom';

each(document.querySelectorAll('.tooltip'), (el) => {
  tippy(el, {
    arrow: true,
    flip: true,
    html: `#${el.dataset.tooltipId}`,
    theme: 'nisource',
    trigger: 'click',
  });
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/components/tooltip.js